async function getRecommendedSessions() {
  const apiUrl = `${import.meta.env.VITE_BASE_API_URL}/schools/recommended-sessions`

  try {
    const response = await fetch(apiUrl, {
      method: 'GET'
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export default { getRecommendedSessions }
